var _rect, _rect2, _text, _text2, _text3, _text4, _ellipse, _rect3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _path, _text5, _rect4, _polygon12, _rect5, _polygon13, _rect6, _polygon14, _rect7, _polygon15, _ellipse2, _path2, _text6, _ellipse3, _path3, _text7, _ellipse4, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXw96(_ref, svgRef) {
  var _React$createElement, _React$createElement2, _React$createElement3, _React$createElement4, _React$createElement5;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 382,
    id: "svg_5",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 5,
    width: 382,
    x: 9,
    y: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#191919",
    height: 183.99999,
    id: "svg_6",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 5,
    width: 261.49998,
    x: 68.00001,
    y: 92.49999
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "bold",
    id: "svg_7",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 109.5,
    xmlSpace: "preserve",
    y: 111
  }, "Hakaru+")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "bold",
    id: "svg_8",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 293.5,
    xmlSpace: "preserve",
    y: 111
  }, "XW-96")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fill: "#ff5656",
    fontFamily: "Roboto",
    fontSize: 40,
    fontWeight: "normal",
    id: "svg_18",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 199.44531,
    xmlSpace: "preserve",
    y: 160
  }, "0000000.0")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "normal",
    id: "svg_16",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 301.5,
    xmlSpace: "preserve",
    y: 210
  }, "MWh")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.5,
    cy: 337,
    fill: "none",
    fillOpacity: 0,
    id: "svg_2",
    rx: 10,
    ry: 17,
    stroke: "#191919",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    transform: "rotate(-45 306.5 337)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#222222",
    height: 4,
    id: "svg_10",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 2,
    width: 11,
    x: 296.5,
    y: 186
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", (_React$createElement = {
    cx: 288,
    cy: 341.5,
    edge: 6.14636,
    fill: "#ffffff",
    id: "svg_12",
    orient: "x",
    points: "304.00978088378906,194.24982282691417 299.1868743821924,197.0343288813674 299.1868743821924,191.46531677246094 304.00978088378906,194.24982282691417 ",
    shape: "regularPoly",
    sides: 3,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 2
  }, _defineProperty(_React$createElement, "strokeWidth", 2), _defineProperty(_React$createElement, "strokecolor", "#000000"), _defineProperty(_React$createElement, "transform", "rotate(-90 301.598 194.25)"), _React$createElement))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    cx: 497,
    cy: 379.5,
    edge: 0,
    fill: "#ffffff",
    id: "svg_13",
    orient: "x",
    shape: "regularPoly",
    sides: 3,
    strokeWidth: 2,
    strokecolor: "#000000"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    cx: 289,
    cy: 344.5,
    edge: 0,
    fill: "#ffffff",
    id: "svg_14",
    orient: "x",
    shape: "regularPoly",
    sides: 3,
    strokeWidth: 2,
    strokecolor: "none"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    cx: 289,
    cy: 341.5,
    edge: 0,
    fill: "#ffffff",
    id: "svg_15",
    orient: "x",
    shape: "regularPoly",
    sides: 3,
    strokeWidth: 2,
    strokecolor: "none"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    cx: 291,
    cy: 337.5,
    edge: 0,
    fill: "#ffffff",
    id: "svg_17",
    orient: "x",
    shape: "regularPoly",
    sides: 3,
    strokeWidth: 2,
    strokecolor: "none"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    cx: 289,
    cy: 344.5,
    edge: 0,
    fill: "#ffffff",
    id: "svg_20",
    orient: "x",
    shape: "regularPoly",
    sides: 3,
    strokeWidth: 2,
    strokecolor: "none"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    cx: 287.75,
    cy: 341.75,
    edge: 0,
    fill: "#ffffff",
    id: "svg_21",
    orient: "x",
    shape: "regularPoly",
    sides: 3,
    strokeWidth: 2,
    strokecolor: "none"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    cx: 289.75,
    cy: 339.75,
    edge: 0,
    fill: "#ffffff",
    id: "svg_25",
    orient: "x",
    shape: "regularPoly",
    sides: 3,
    strokeWidth: 2,
    strokecolor: "none"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    cx: 350.75,
    cy: 314.25,
    edge: 0,
    fill: "#ffffff",
    id: "svg_29",
    orient: "x",
    shape: "regularPoly",
    sides: 3,
    strokeWidth: 2,
    strokecolor: "none"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    cx: 380.75,
    cy: 346.75,
    edge: 0,
    fill: "#ffffff",
    id: "svg_30",
    orient: "x",
    shape: "regularPoly",
    sides: 3,
    strokeWidth: 2,
    strokecolor: "none"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    cx: 358.25,
    cy: 311.75,
    edge: 0,
    fill: "#ffffff",
    id: "svg_31",
    orient: "x",
    shape: "regularPoly",
    sides: 3,
    strokeWidth: 2,
    strokecolor: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m296.00372,243.62122l11.68993,0l9.74161,18.24998l-9.74161,18.24998l-11.68993,0l0,-36.49996z",
    fill: "#ffffff",
    id: "svg_33",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 5,
    transform: "rotate(90 306.719 261.871)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fill: "#191919",
    fontFamily: "Roboto",
    fontSize: 9,
    fontWeight: "normal",
    id: "svg_34",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 306.5,
    xmlSpace: "preserve",
    y: 262
  }, "DISPLAY")), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "normal",
    id: "svg_35",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    style: {
      cursor: "move"
    },
    textAnchor: "middle",
    x: 270.5,
    xmlSpace: "preserve",
    y: 210
  }, "kWh"), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ff5656",
    height: 4,
    id: "svg_36",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 2,
    width: 11,
    x: 265.5,
    y: 186
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", (_React$createElement2 = {
    cx: 288,
    cy: 341.5,
    edge: 6.14636,
    fill: "#ffffff",
    id: "svg_37",
    orient: "x",
    points: "273.009765625,194.24981689453125 268.1868591308594,197.03433227539062 268.1868591308594,191.46531677246094 273.009765625,194.24981689453125 ",
    shape: "regularPoly",
    sides: 3,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 2
  }, _defineProperty(_React$createElement2, "strokeWidth", 2), _defineProperty(_React$createElement2, "strokecolor", "#000000"), _defineProperty(_React$createElement2, "transform", "rotate(-90 270.598 194.25)"), _React$createElement2))), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "normal",
    id: "svg_38",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    style: {
      cursor: "move"
    },
    textAnchor: "middle",
    x: 240,
    xmlSpace: "preserve",
    y: 210
  }, "INT"), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#222222",
    height: 4,
    id: "svg_39",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 2,
    width: 11,
    x: 235,
    y: 186
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", (_React$createElement3 = {
    cx: 288,
    cy: 341.5,
    edge: 6.14636,
    fill: "#ffffff",
    id: "svg_40",
    orient: "x",
    points: "242.509765625,194.24981689453125 237.68685913085938,197.03433227539062 237.68685913085938,191.46531677246094 242.509765625,194.24981689453125 ",
    shape: "regularPoly",
    sides: 3,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 2
  }, _defineProperty(_React$createElement3, "strokeWidth", 2), _defineProperty(_React$createElement3, "strokecolor", "#000000"), _defineProperty(_React$createElement3, "transform", "rotate(-90 240.098 194.25)"), _React$createElement3))), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "normal",
    id: "svg_41",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    style: {
      cursor: "move"
    },
    textAnchor: "middle",
    x: 211,
    xmlSpace: "preserve",
    y: 210
  }, "RD"), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#222222",
    height: 4,
    id: "svg_42",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 2,
    width: 11,
    x: 206,
    y: 186
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", (_React$createElement4 = {
    cx: 288,
    cy: 341.5,
    edge: 6.14636,
    fill: "#ffffff",
    id: "svg_43",
    orient: "x",
    points: "213.509765625,194.24981689453125 208.68685913085938,197.03433227539062 208.68685913085938,191.46531677246094 213.509765625,194.24981689453125 ",
    shape: "regularPoly",
    sides: 3,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 2
  }, _defineProperty(_React$createElement4, "strokeWidth", 2), _defineProperty(_React$createElement4, "strokecolor", "#000000"), _defineProperty(_React$createElement4, "transform", "rotate(-90 211.098 194.25)"), _React$createElement4))), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "normal",
    id: "svg_44",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    style: {
      cursor: "move"
    },
    textAnchor: "middle",
    x: 181,
    xmlSpace: "preserve",
    y: 210
  }, "SD"), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#222222",
    height: 4,
    id: "svg_45",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 2,
    width: 11,
    x: 176,
    y: 186
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", (_React$createElement5 = {
    cx: 288,
    cy: 341.5,
    edge: 6.14636,
    fill: "#ffffff",
    id: "svg_46",
    orient: "x",
    points: "183.509765625,194.24981689453125 178.68685913085938,197.03433227539062 178.68685913085938,191.46531677246094 183.509765625,194.24981689453125 ",
    shape: "regularPoly",
    sides: 3,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 2
  }, _defineProperty(_React$createElement5, "strokeWidth", 2), _defineProperty(_React$createElement5, "strokecolor", "#000000"), _defineProperty(_React$createElement5, "transform", "rotate(-90 181.098 194.25)"), _React$createElement5))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 258,
    cy: 336,
    fill: "none",
    fillOpacity: 0,
    id: "svg_47",
    rx: 10,
    ry: 17,
    stroke: "#191919",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    transform: "rotate(-45 258 336)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m247.50372,242.62122l11.68993,0l9.74161,18.24999l-9.74161,18.24998l-11.68993,0l0,-36.49997z",
    fill: "#ffffff",
    id: "svg_48",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 5,
    transform: "rotate(90 258.219 260.871)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fill: "#191919",
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "normal",
    id: "svg_49",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 258,
    xmlSpace: "preserve",
    y: 259.5
  }, "_")), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.5,
    cy: 336,
    fill: "none",
    fillOpacity: 0,
    id: "svg_50",
    rx: 10,
    ry: 17,
    stroke: "#191919",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    transform: "rotate(-45 209.5 336)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m199.00372,242.62122l11.68993,0l9.74161,18.24999l-9.74161,18.24998l-11.68993,0l0,-36.49997z",
    fill: "#ffffff",
    id: "svg_51",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 5,
    transform: "rotate(90 209.719 260.871)"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    fill: "#191919",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_52",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 209.5,
    xmlSpace: "preserve",
    y: 264
  }, "+")), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.5,
    cy: 336.5,
    fill: "none",
    fillOpacity: 0,
    id: "svg_53",
    rx: 10,
    ry: 17,
    stroke: "#191919",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    transform: "rotate(-45 160.5 336.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m150.00372,243.12122l11.68993,0l9.74161,18.24999l-9.74161,18.24998l-11.68993,0l0,-36.49997z",
    fill: "#ffffff",
    id: "svg_54",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 5,
    transform: "rotate(90 160.719 261.371)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#191919",
    fontFamily: "Roboto",
    fontSize: 9,
    fontWeight: "normal",
    id: "svg_55",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    style: {
      cursor: "move"
    },
    textAnchor: "middle",
    x: 160.5,
    xmlSpace: "preserve",
    y: 261.5
  }, "SET")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXw96);
export default __webpack_public_path__ + "static/media/xw96.37babc81.svg";
export { ForwardRef as ReactComponent };